export default {
    selectCashOutRecordList:
        "/gateway/huilianOperation/cashOutcs/selectCashOutRecordList", // 提现记录列表查询
};



// WEBPACK FOOTER //
// ./src/withdrawalRecordsList/index/api.js